'use client' 

import dynamic from "next/dynamic"

const DetailBook = dynamic(()=> import('../component/PageEbook/detail_book'),{ssr:false});
const ReviewBook = dynamic(()=>import('../component/PageEbook/review_book'),{ssr:false});
const MoreBook = dynamic(()=>import('../component/PageEbook/more_book'),{ssr:false})


const EBookPage = ({Edata}) => {
    // console.log(Edata)
    return(
        <div className=" grid grid-cols-12  xl:max-w-[1200px] gap-[30px] md:gap-[40px]  xl:mx-auto my-[24px] md:my-[56px]">
            <div className="col-span-12 ">
                <DetailBook book_data={Edata?.EbookData} />
            </div>
            <div className="page-surface text-primary col-span-12 h-[59px] flex items-center text-center justify-center px-[16px] md:px-[32px]">Eve E-Book ไม่รองรับการอ่านบนเว็บไซต์ สามารถเข้าไปอ่านได้ที่ชั้นหนังสือของแอปพลิเคชั่นเท่านั้น</div>
            <div className="col-span-12  xl:col-span-8  px-[16px] md:px-[32px]">
                <ReviewBook review={Edata?.Review} book_data={Edata?.EbookData} />
            </div>
            <div className="col-span-12  md:col-span-7 xl:col-span-4 px-[16px] md:px-[32px]">
                <MoreBook runbook={Edata?.RunBook} otherbook={Edata?.Other_Book} partner={Edata?.EbookData['Edata.partner.name']} />
            </div>
        </div>
    )
}

export default EBookPage